import { types } from 'mobx-state-tree';
import { Poi } from '../poi';
import { fetchSearchResults } from './flows/fetch-search-results';

export const Recomandation = types.model({
  title: types.string,
  text: types.string,
  icon: types.string,
});

export const Distance = types.enumeration([
  'small',
  'medium',
  'large',
  'infinite',
]);
export const DistancesKm = types.model({
  small: types.number,
  medium: types.number,
  large: types.number,
  infinite: types.number, // 0 = infinite
});
export const Distances = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  infinite: 'infinite',
};

export const SearchResult = types.model({
  poi: Poi,
  distance: types.maybeNull(types.number),
});

export const SearchStore = types
  .model({
    recommendations: types.optional(types.array(Recomandation), []),
    searchRadius: types.optional(Distance, 'infinite'),
    searchResults: types.optional(types.array(SearchResult), []),
    loading: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setSearchRadius: (radius) => (self.searchRadius = radius),
    fetchSearchResults: (...args) => fetchSearchResults(self, ...args),
    clearSearchResults: () => (self.searchResults = []),
    setLoadingStatus: () => (self.loading = true),
  }));

export const initialState = {
  recommendations: [],
  searchResults: [
    {
      poi: {
        address: {
          city: 'Harlowton',
          country: '',
          zipCode: '59036',
          street: 'Central Avenue South',
          number: '106',
        },
        en: {
          title: 'Graves Hotel',
          description:
            "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
          openingHours: null,
        },
        de: {
          title: 'Graves Hotel',
          description:
            "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
          openingHours: null,
        },
        fr: {
          title: 'Graves Hotel',
          description:
            "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
          openingHours: null,
        },
        nl: {
          title: 'Graves Hotel',
          description:
            "The Graves Hotel is a historic hotel located at 106 South Central Avenue in Harlowton, Montana. A. C. Graves, a leading figure in Harlowton's early development, had the hotel built in 1909; it was one of the first businesses to be built after a fire destroyed much of downtown Harlowton in 1907. The hotel was the first sandstone building in Harlowton, though the stone eventually became a common building material; its design features a projecting corner oriel window topped by a metal cupola. In addition to hosting visitors and railroad travelers, the hotel also served as a community meeting place and business center.The hotel was added to the National Register of Historic Places on August 6, 1980.",
          openingHours: null,
        },
        _id: '6266b1ed6de2f1eae9988a26',
        id: 'sygic-poi:17695703',
        categories: [
          {
            name: 'eatdrink',
            color: '#FF7400',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e871',
            __v: 0,
          },
        ],
        eMail: null,
        images: [],
        localRating: 0.0260096153846155,
        location: {
          type: 'Point',
          coordinates: [-109.8313231, 46.4343933],
        },
        phone: null,
        provider: 'sygic',
        rating: 3,
        sunnyRating: 10,
        url: 'http://www.graveshotel.org/',
        copyright: {
          source: 'Sygic Maps',
          sourceUrl: 'https://www.sygic.com/',
          _id: '62b1ec37a4be76a4e62c6d4e',
        },
      },
    },
    {
      poi: {
        address: {
          city: 'Seattle',
          country: "États-Unis d'Amérique",
          zipCode: '98104',
          street: 'Madison Street',
          number: '900',
        },
        en: {
          title: 'Sorrento Hotel',
          description:
            "Hotel Sorrento is an Italian oasis style hotel in Seattle, Washington, United States, located in the historic First Hill neighborhood.The Hotel Sorrento opened in 1909, just before the Alaska-Yukon-Pacific Exposition was held in the city. Developed by a Seattle clothier named Samuel Rosenberg, the hotel was under financial distress in its early existence. After suffering losses, in 1910 Rosenberg traded the hotel for a 240-acre orchard in Oregon's Rogue River Valley. Incidentally, Rosenberg's sons, Harry and David, assumed management of the orchard, selling their prized pears in baskets under the famed Harry & David nameplate.\n\nAmong the hotel's architectural features, the Rookwood tiles composing the fireplace surround in the Fireside Room are especially noteworthy.",
          openingHours: null,
        },
        de: {
          title: 'Sorrento Hotel',
          description:
            "Hotel Sorrento is an Italian oasis style hotel in Seattle, Washington, United States, located in the historic First Hill neighborhood.The Hotel Sorrento opened in 1909, just before the Alaska-Yukon-Pacific Exposition was held in the city. Developed by a Seattle clothier named Samuel Rosenberg, the hotel was under financial distress in its early existence. After suffering losses, in 1910 Rosenberg traded the hotel for a 240-acre orchard in Oregon's Rogue River Valley. Incidentally, Rosenberg's sons, Harry and David, assumed management of the orchard, selling their prized pears in baskets under the famed Harry & David nameplate.\n\nAmong the hotel's architectural features, the Rookwood tiles composing the fireplace surround in the Fireside Room are especially noteworthy.",
          openingHours: null,
        },
        fr: {
          title: 'Sorrento Hotel',
          description:
            "Hotel Sorrento is an Italian oasis style hotel in Seattle, Washington, United States, located in the historic First Hill neighborhood.The Hotel Sorrento opened in 1909, just before the Alaska-Yukon-Pacific Exposition was held in the city. Developed by a Seattle clothier named Samuel Rosenberg, the hotel was under financial distress in its early existence. After suffering losses, in 1910 Rosenberg traded the hotel for a 240-acre orchard in Oregon's Rogue River Valley. Incidentally, Rosenberg's sons, Harry and David, assumed management of the orchard, selling their prized pears in baskets under the famed Harry & David nameplate.\n\nAmong the hotel's architectural features, the Rookwood tiles composing the fireplace surround in the Fireside Room are especially noteworthy.",
          openingHours: null,
        },
        nl: {
          title: 'Sorrento Hotel',
          description:
            "Hotel Sorrento is an Italian oasis style hotel in Seattle, Washington, United States, located in the historic First Hill neighborhood.The Hotel Sorrento opened in 1909, just before the Alaska-Yukon-Pacific Exposition was held in the city. Developed by a Seattle clothier named Samuel Rosenberg, the hotel was under financial distress in its early existence. After suffering losses, in 1910 Rosenberg traded the hotel for a 240-acre orchard in Oregon's Rogue River Valley. Incidentally, Rosenberg's sons, Harry and David, assumed management of the orchard, selling their prized pears in baskets under the famed Harry & David nameplate.\n\nAmong the hotel's architectural features, the Rookwood tiles composing the fireplace surround in the Fireside Room are especially noteworthy.",
          openingHours: null,
        },
        _id: '6266b2036de2f1eae998e65e',
        id: 'sygic-poi:2160630',
        categories: [
          {
            name: 'sight',
            color: '#C00CAA',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e872',
            __v: 0,
          },
        ],
        eMail: null,
        images: [],
        localRating: 0.0160096153846155,
        location: {
          type: 'Point',
          coordinates: [-122.3268403, 47.6089653],
        },
        phone: '+1 800 426 1265',
        provider: 'sygic',
        rating: 4,
        sunnyRating: 10,
        url: 'https://en.wikipedia.org/wiki/Sorrento_Hotel',
        copyright: {
          source: 'Sygic Maps',
          sourceUrl: 'https://www.sygic.com/',
          _id: '62b1ec80a4be76a4e62d3403',
        },
      },
    },
    {
      poi: {
        address: {
          city: 'Milwaukee',
          country: '',
          zipCode: '53202',
          street: 'East Wisconsin Avenue',
          number: '424',
        },
        en: {
          title: 'The Pfister Hotel',
          description:
            'The Pfister Hotel is a luxury AAA Four Diamond Award hotel in downtown Milwaukee, Wisconsin, United States. The Pfister Hotel is a member of Historic Hotels of America, the official program of the National Trust for Historic Preservation.\n\nOwned by Guido Pfister and his son, Charles F. Pfister, it was opened in 1893 at a cost of over $1 million. Designed by architect Henry C. Koch in Romanesque Revival style, it had features uncommon in its time like fireproofing, electricity, and thermostat controls.\n\nThe hotel was purchased by hospitality magnate Ben Marcus in 1962, who renovated the hotel and added a 13-story addition behind the building without compromising the original building itself, and continues to be owned by the Marcus Corporation.',
          openingHours: null,
        },
        de: {
          title: 'The Pfister Hotel',
          description:
            'The Pfister Hotel is a luxury AAA Four Diamond Award hotel in downtown Milwaukee, Wisconsin, United States. The Pfister Hotel is a member of Historic Hotels of America, the official program of the National Trust for Historic Preservation.\n\nOwned by Guido Pfister and his son, Charles F. Pfister, it was opened in 1893 at a cost of over $1 million. Designed by architect Henry C. Koch in Romanesque Revival style, it had features uncommon in its time like fireproofing, electricity, and thermostat controls.\n\nThe hotel was purchased by hospitality magnate Ben Marcus in 1962, who renovated the hotel and added a 13-story addition behind the building without compromising the original building itself, and continues to be owned by the Marcus Corporation.',
          openingHours: null,
        },
        fr: {
          title: 'The Pfister Hotel',
          description:
            'The Pfister Hotel est un hôtel américain situé à Milwaukee, dans le Wisconsin. Construit en 1893, cet établissement est membre des Historic Hotels of America depuis 1994.',
          openingHours: null,
        },
        nl: {
          title: 'The Pfister Hotel',
          description:
            'The Pfister Hotel is a luxury AAA Four Diamond Award hotel in downtown Milwaukee, Wisconsin, United States. The Pfister Hotel is a member of Historic Hotels of America, the official program of the National Trust for Historic Preservation.\n\nOwned by Guido Pfister and his son, Charles F. Pfister, it was opened in 1893 at a cost of over $1 million. Designed by architect Henry C. Koch in Romanesque Revival style, it had features uncommon in its time like fireproofing, electricity, and thermostat controls.\n\nThe hotel was purchased by hospitality magnate Ben Marcus in 1962, who renovated the hotel and added a 13-story addition behind the building without compromising the original building itself, and continues to be owned by the Marcus Corporation.',
          openingHours: null,
        },
        _id: '6266b2036de2f1eae998e418',
        id: 'sygic-poi:2357457',
        categories: [
          {
            name: 'sight',
            color: '#C00CAA',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e872',
            __v: 0,
          },
        ],
        eMail: null,
        images: [],
        localRating: 0.016662798408488,
        location: {
          type: 'Point',
          coordinates: [-87.9057298, 43.0394425],
        },
        phone: '+1 414 273 8222',
        provider: 'sygic',
        rating: 4,
        sunnyRating: 10,
        url: 'https://fr.wikipedia.org/wiki/The_Pfister_Hotel',
        copyright: {
          source: 'Sygic Maps',
          sourceUrl: 'https://www.sygic.com/',
          _id: '62b1ec80a4be76a4e62d300f',
        },
      },
    },
    {
      poi: {
        address: {
          city: 'Toronto',
          country: '',
          zipCode: '',
          street: 'Yonge Street',
          number: '335',
        },
        en: {
          title: 'Empress Hotel',
          description:
            'The Empress Hotel was a three-storey red-brick building at the corner of Yonge and Gould streets in downtown Toronto. It was destroyed by fire on January 3, 2011.\n\nThe hotel was opened in 1888.\n\nThe hotel changed hands several times.\n\nThe property ceased operating as a hotel in the mid-1970s.',
          openingHours: null,
        },
        de: {
          title: 'Empress Hotel',
          description:
            'The Empress Hotel was a three-storey red-brick building at the corner of Yonge and Gould streets in downtown Toronto. It was destroyed by fire on January 3, 2011.\n\nThe hotel was opened in 1888.\n\nThe hotel changed hands several times.\n\nThe property ceased operating as a hotel in the mid-1970s.',
          openingHours: null,
        },
        fr: {
          title: 'Empress Hotel',
          description:
            'The Empress Hotel was a three-storey red-brick building at the corner of Yonge and Gould streets in downtown Toronto. It was destroyed by fire on January 3, 2011.\n\nThe hotel was opened in 1888.\n\nThe hotel changed hands several times.\n\nThe property ceased operating as a hotel in the mid-1970s.',
          openingHours: null,
        },
        nl: {
          title: 'Empress Hotel',
          description:
            'The Empress Hotel was a three-storey red-brick building at the corner of Yonge and Gould streets in downtown Toronto. It was destroyed by fire on January 3, 2011.\n\nThe hotel was opened in 1888.\n\nThe hotel changed hands several times.\n\nThe property ceased operating as a hotel in the mid-1970s.',
          openingHours: null,
        },
        _id: '6266b1f06de2f1eae9989923',
        id: 'sygic-poi:35634338',
        categories: [
          {
            name: 'eatdrink',
            color: '#FF7400',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e871',
            __v: 0,
          },
        ],
        eMail: null,
        images: [
          {
            title:
              'Site of a historic old building, on Yonge Street, once the fire-damaged remains of the building were removed.  On the ground floor, on the Gould…',
            author: 'Geo Swan',
            authorUrl: 'http://commons.wikimedia.org/wiki/User:Geo_Swan',
            license: 'Public domain',
            url: 'https://media-cdn.sygictraveldata.com/media/612664395a40232133447d33247d38313134343033393537.jpg',
            _id: '62b1ec45a4be76a4e62c8e76',
          },
        ],
        localRating: 0.023605769230769,
        location: {
          type: 'Point',
          coordinates: [-79.3809494, 43.6573305],
        },
        phone: null,
        provider: 'sygic',
        rating: 4,
        sunnyRating: 10,
        url: '',
        copyright: {
          source: 'Sygic Maps',
          sourceUrl: 'https://www.sygic.com/',
          _id: '62b1ec45a4be76a4e62c8e77',
        },
      },
    },
    {
      poi: {
        address: {
          city: 'Newport, Wales',
          country: 'Royaume-Uni',
          zipCode: '',
          street: '',
          number: '',
        },
        en: {
          title: 'Westgate Hotel',
          description:
            'The Westgate Hotel, Commercial Street, Newport, Wales is a hotel building dating from the 19th century. On 4 November 1839 the hotel saw the major scenes of the Newport Rising, when 3,000 Chartists led by John Frost marched on Newport to attempt to secure the release of five of their number who were being held under arrest at the hotel. Around 100 British Army soldiers killed 22 of the civilian Chartists and wounded more than 50. The hotel is a Grade II listed building.',
          openingHours: null,
        },
        de: {
          title: 'Westgate Hotel',
          description:
            'The Westgate Hotel, Commercial Street, Newport, Wales is a hotel building dating from the 19th century. On 4 November 1839 the hotel saw the major scenes of the Newport Rising, when 3,000 Chartists led by John Frost marched on Newport to attempt to secure the release of five of their number who were being held under arrest at the hotel. Around 100 British Army soldiers killed 22 of the civilian Chartists and wounded more than 50. The hotel is a Grade II listed building.',
          openingHours: null,
        },
        fr: {
          title: 'Westgate Hotel',
          description:
            'The Westgate Hotel, Commercial Street, Newport, Wales is a hotel building dating from the 19th century. On 4 November 1839 the hotel saw the major scenes of the Newport Rising, when 3,000 Chartists led by John Frost marched on Newport to attempt to secure the release of five of their number who were being held under arrest at the hotel. Around 100 British Army soldiers killed 22 of the civilian Chartists and wounded more than 50. The hotel is a Grade II listed building.',
          openingHours: null,
        },
        nl: {
          title: 'Westgate Hotel',
          description:
            'The Westgate Hotel, Commercial Street, Newport, Wales is a hotel building dating from the 19th century. On 4 November 1839 the hotel saw the major scenes of the Newport Rising, when 3,000 Chartists led by John Frost marched on Newport to attempt to secure the release of five of their number who were being held under arrest at the hotel. Around 100 British Army soldiers killed 22 of the civilian Chartists and wounded more than 50. The hotel is a Grade II listed building.',
          openingHours: null,
        },
        _id: '6266b7136de2f1eae9a168f7',
        id: 'sygic-poi:45892605',
        categories: [
          {
            name: 'sight',
            color: '#C00CAA',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e872',
            __v: 0,
          },
        ],
        eMail: null,
        images: [
          {
            title: 'Newport, Westgate Hotel',
            author: 'Mike Faherty',
            authorUrl: 'https://www.geograph.org.uk/profile/30470',
            license: 'CC BY-SA 2.0',
            licenseUrl: 'https://creativecommons.org/licenses/by-sa/2.0',
            url: 'https://media-cdn.sygictraveldata.com/media/612664395a40232133447d33247d38313530333632313431.jpg',
            _id: '62b1f252a4be76a4e638bc1c',
          },
        ],
        localRating: 0,
        location: {
          type: 'Point',
          coordinates: [-2.9964359, 51.5875771],
        },
        phone: null,
        provider: 'sygic',
        rating: 3,
        sunnyRating: 10,
        url: 'https://en.wikipedia.org/wiki/Westgate_Hotel',
        copyright: {
          source: 'Sygic Maps',
          sourceUrl: 'https://www.sygic.com/',
          _id: '62b1f252a4be76a4e638bc1d',
        },
      },
    },
    {
      poi: {
        address: {
          city: 'Düsseldorf',
          country: 'DE',
          zipCode: '40210',
          street: 'Immermannstraße',
          number: '41',
        },
        en: {
          title: 'Hotel Nikko Düsseldorf',
          description:
            'The Hotel Nikko Düsseldorf is a Japanese-owned hotel  prominent in  Düsseldorf  since 1978. Located in Stadtmitte, the hotel opened in 1978 in conjunction with the German-Japanese Center. It has undergone one major expansion in 2009 and recently renovated all rooms in the major wing. Also, a renovation of the spa and conference facilities is scheduled for summer 2013. In 2018 a complete renovation of 220 guest rooms, lobby, F&B, entrance and many more has been done.\n\nAt the present time the Hotel Nikko Düsseldorf is the biggest hotel located in the center of Düsseldorf with 386 rooms. The hotel has three restaurants on the premises.The Hotel Nikko Düsseldorf is part of Okura Nikko Hotel Management.',
          openingHours: null,
        },
        de: {
          title: 'Hotel Nikko',
          description:
            'The Hotel Nikko Düsseldorf is a Japanese-owned hotel  prominent in  Düsseldorf  since 1978. Located in Stadtmitte, the hotel opened in 1978 in conjunction with the German-Japanese Center. It has undergone one major expansion in 2009 and recently renovated all rooms in the major wing. Also, a renovation of the spa and conference facilities is scheduled for summer 2013. In 2018 a complete renovation of 220 guest rooms, lobby, F&B, entrance and many more has been done.\n\nAt the present time the Hotel Nikko Düsseldorf is the biggest hotel located in the center of Düsseldorf with 386 rooms. The hotel has three restaurants on the premises.The Hotel Nikko Düsseldorf is part of Okura Nikko Hotel Management.',
          openingHours: null,
        },
        fr: {
          title: 'Hotel Nikko Düsseldorf',
          description:
            'The Hotel Nikko Düsseldorf is a Japanese-owned hotel  prominent in  Düsseldorf  since 1978. Located in Stadtmitte, the hotel opened in 1978 in conjunction with the German-Japanese Center. It has undergone one major expansion in 2009 and recently renovated all rooms in the major wing. Also, a renovation of the spa and conference facilities is scheduled for summer 2013. In 2018 a complete renovation of 220 guest rooms, lobby, F&B, entrance and many more has been done.\n\nAt the present time the Hotel Nikko Düsseldorf is the biggest hotel located in the center of Düsseldorf with 386 rooms. The hotel has three restaurants on the premises.The Hotel Nikko Düsseldorf is part of Okura Nikko Hotel Management.',
          openingHours: null,
        },
        nl: {
          title: 'Hotel Nikko Düsseldorf',
          description:
            'The Hotel Nikko Düsseldorf is a Japanese-owned hotel  prominent in  Düsseldorf  since 1978. Located in Stadtmitte, the hotel opened in 1978 in conjunction with the German-Japanese Center. It has undergone one major expansion in 2009 and recently renovated all rooms in the major wing. Also, a renovation of the spa and conference facilities is scheduled for summer 2013. In 2018 a complete renovation of 220 guest rooms, lobby, F&B, entrance and many more has been done.\n\nAt the present time the Hotel Nikko Düsseldorf is the biggest hotel located in the center of Düsseldorf with 386 rooms. The hotel has three restaurants on the premises.The Hotel Nikko Düsseldorf is part of Okura Nikko Hotel Management.',
          openingHours: null,
        },
        _id: '6266b1e06de2f1eae9984ab1',
        id: 'sygic-poi:47101',
        categories: [
          {
            name: 'eatdrink',
            color: '#FF7400',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e871',
            __v: 0,
          },
          {
            name: 'sight',
            color: '#C00CAA',
            active: true,
            selected: true,
            _id: '62442cf9269e8eed7f88e872',
            __v: 0,
          },
        ],
        eMail: 'info@nikko-hotel.de',
        images: [
          {
            title: 'Japan Center Düsseldorf',
            author: 'Marek Gehrmann',
            authorUrl: 'http://commons.wikimedia.org/wiki/User:Marek_Gehrmann',
            license: 'CC BY-SA 3.0',
            licenseUrl: 'http://creativecommons.org/licenses/by-sa/3.0',
            url: 'https://media-cdn.sygictraveldata.com/media/612664395a40232133447d33247d383335353235393232.jpg',
            _id: '62b1ec06a4be76a4e62bc7b1',
          },
        ],
        localRating: 0.057601114584575,
        location: {
          type: 'Point',
          coordinates: [6.788524, 51.2228924],
        },
        phone: '+49 211 834-0',
        provider: 'sygic',
        rating: 5,
        sunnyRating: 10,
        url: 'https://www.facebook.com/HotelNikkoDusseldorf',
        copyright: {
          source: 'Sygic Maps',
          sourceUrl: 'https://www.sygic.com/',
          _id: '62b1ec06a4be76a4e62bc7b2',
        },
      },
    },
  ],
};
